import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { findUsername } from "../components/generic/UserCell";
import { getUserId } from "../redux/slices/userSlice";
import useResources from "./useResources";

const useUserName = () => {
  const userId = useSelector((state) => getUserId(state));
  const { employees } = useResources();

  const [userName, setUserName] = useState(findUsername(employees, userId));

  useEffect(() => {
    setUserName(findUsername(employees, userId));
  }, [employees, userId]);
  return userName;
};

export default useUserName;
